var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar-container"},[_c('img',{staticClass:"avatar",attrs:{"src":_setup.src,"onerror":_setup.handleError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }